import {
    getApiErrorMessage,
    getFormMode,
    getResponseData
} from 'lib/formUtils';
import {
    Box,
    Button,
    CardContent,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    FormLabel,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from '@material-ui/core';
import {
    Book,
    Description,
    PhotoCamera
} from '@material-ui/icons';
import {
    ANAO,
    ASIM,
    ATIPO_MODELO_RELATORIO_PARA_MAPA_DE_TRANSPORTE
} from 'consts';
import api from 'services/api';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AlertInformation } from 'components';
import { safeSetState } from 'lib/reactUtils';
import { getConfigField } from 'lib/configUtils';
import { getCodUsuarioRegistrou } from 'lib/functions';
import { FormActions, FormStatusSwitch } from 'views/Components';
import DicionarioDadosFornecedor from '../DicionarioDadosFornecedor';

const ROTA_LISTA = '/crm/msgwhatsappfornecedor';

const TIPOS_IMAGEM = [
    'image/jpeg',
    'image/png',
    'image/jpg'
];

const TIPOS_PDF = ['application/pdf'];

/* Campos que são convertidos para número no onChange */
const CAMPOS_NUMERICOS = [
    'tipomensagem',
    'recurso',
    'codmodelorelatorio'
];

/* Campos que não são convertidos para caixa alta no onChange */
const CAMPOS_SEM_CAIXA_ALTA = [
    'botao1',
    'botao2'
];

const ESTILO_BOTAO_CINZA = {
    backgroundColor: '#e0e0e0'
};

const MENU_PROPS = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
    },
    getContentAnchorEl: null
};

/* Converte o ArrayBuffer para base64 (para PDFs) */
const arrayBufferToBase64 = (buffer) => {
    let binary = '';

    const bytes = new Uint8Array(buffer);
    const length = bytes.byteLength;

    for (let i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
};

/* Cria o link de download do PDF a partir do base64 */
const getPdfDownloadLink = (base64Data) => {
    const bytes = Uint8Array.from(atob(base64Data), char => char.charCodeAt(0));
    const pdfFile = new Blob([bytes], { type: 'application/pdf' });

    return URL.createObjectURL(pdfFile);
};

class MsgWhatsAppFornecedorForm extends Component {
    _isMounted = false;
    safeSetState = safeSetState;

    state = {
        mensagem: {},
        modelosrelatorio: [],
        arquivoPreview: null,
        downloadLink: null,
        isNewRecord: false,
        isView: false,
        openDictionaryModal: false,
        openAlert: false,
        messageAlert: '',
        errors: {}
    };

    /* Carrega os dados iniciais da tela */
    async componentDidMount() {
        this._isMounted = true;

        const {
            id,
            isNewRecord,
            isView
        } = getFormMode(this.props.match, this.props.location);

        try {
            if (isNewRecord) {
                this.setState({ isNewRecord: true });

                return;
            }

            if (id !== '' && !isNaN(Number(id))) {
                await this.loadMensagem(id, isView);
            }
        } catch (error) {
            console.error(
                'Erro ao carregar a mensagem:',
                error.response?.data || error.message
            );

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao carregar a mensagem!'
                )
            );
        }
    };

    /* Limpa a flag de montagem ao sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Carrega a mensagem */
    loadMensagem = async (id, isView) => {
        const response = await api.get(`/whatsapp/mensagemfornecedor/${id}`);
        const registro = getResponseData(response)[0];

        if (!registro) {
            this.handleOpenAlert('Mensagem não encontrada!');

            return;
        }

        const { arquivobase64, extensaoarquivo, recurso, tipomensagem } = registro;

        let arquivoPreview = '';
        let downloadLink = '';

        // imagem: usa o base64 para a pré-visualização
        if (tipomensagem === 3) {
            arquivoPreview = `data:image/${extensaoarquivo};base64,${arquivobase64}`;
        }

        // documento: gera o link de download do PDF
        if (tipomensagem === 2 && extensaoarquivo === 'pdf') {
            downloadLink = getPdfDownloadLink(arquivobase64);
        }

        if (recurso) {
            this.carregaModelosRelatorio(recurso);
        }

        this.safeSetState({
            mensagem: registro,
            arquivoPreview,
            downloadLink,
            isNewRecord: false,
            isView
        });
    };

    /* Carrega os modelos de relatório do recurso */
    carregaModelosRelatorio = async (recurso) => {
        try {
            const response = await api.get(
                `/modelorelatorio/active/true?tbmodelorelatorio.tipomodelo=${recurso}`
            );

            this.safeSetState({ modelosrelatorio: response.data });
        } catch (error) {
            console.error('Erro ao carregar os modelos de relatório:', error);

            this.safeSetState({ modelosrelatorio: [] });
        }
    };

    /* Evento onChange componentes */
    onChange = (event) => {
        const { name, type, value, checked } = event.target;
        const complemento = {};

        let adjustedValue = value;

        switch (type) {
            case 'checkbox':
                if (name === 'inativo') {
                    adjustedValue = checked ? ANAO : ASIM;
                } else {
                    adjustedValue = checked ? ASIM : ANAO;
                }

                break;
            case 'textarea':
                break;
            case 'radio':
                adjustedValue = Number(value);

                break;
            default:
                if (CAMPOS_NUMERICOS.includes(name)) {
                    adjustedValue = Number(value);

                    if (name === 'tipomensagem') {
                        if (value === 2) {
                            complemento.tipoarquivo = 1;
                        }
                    } else if (name === 'recurso') {
                        complemento.codmodelorelatorio = 0;

                        this.carregaModelosRelatorio(value);
                    }
                } else if (!CAMPOS_SEM_CAIXA_ALTA.includes(name)) {
                    adjustedValue = value.toUpperCase();
                }

                break;
        }

        this.setState(prevState => ({
            mensagem: {
                ...prevState.mensagem,
                ...complemento,
                [name]: adjustedValue
            },
            errors: {
                ...prevState.errors,
                [name]: ''
            }
        }));
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.safeSetState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Abre o modal do dicionário */
    openDictionaryModal = () => {
        this.setState({ openDictionaryModal: true });
    };

    /* Fecha o modal do dicionário */
    closeDictionaryModal = () => {
        this.setState({ openDictionaryModal: false });
    };

    /* Carrega o arquivo (imagem ou PDF) selecionado */
    handleImageUpload = (event) => {
        const { tipomensagem } = this.state.mensagem;
        const file = event.target.files[0];

        if (!file) return;

        const fileType = file.type;

        if (tipomensagem === 2 && !TIPOS_PDF.includes(fileType)) {
            this.handleOpenAlert('Por favor, selecione apenas arquivo PDF.');

            return;
        }

        if (tipomensagem === 3 && !TIPOS_IMAGEM.includes(fileType)) {
            this.handleOpenAlert('Por favor, selecione apenas arquivo de imagem (JPEG/PNG).');

            return;
        }

        const reader = new FileReader();

        reader.onloadend = () => {
            if (!reader.result) return;

            const caminho = file.webkitRelativePath || file.name;
            const nome = file.name;
            const extensao = nome.split('.').pop().toLowerCase();

            let arquivoPreview = null;
            let downloadLink = null;
            let arquivobase64 = null;

            if (TIPOS_IMAGEM.includes(fileType)) {
                // imagem: usa o base64 para a visualização e extrai o base64 da Data URL
                arquivoPreview = reader.result;
                arquivobase64 = reader.result.split(',')[1];
            } else if (TIPOS_PDF.includes(fileType)) {
                // PDF: cria o link do arquivo e converte o ArrayBuffer para base64
                const pdfFile = new Blob([reader.result], { type: 'application/pdf' });

                downloadLink = URL.createObjectURL(pdfFile);
                arquivobase64 = arrayBufferToBase64(reader.result);
            }

            this.setState(prevState => ({
                mensagem: {
                    ...prevState.mensagem,
                    arquivobase64,
                    caminhoearquivo: caminho,
                    nomearquivo: nome,
                    extensaoarquivo: extensao
                },
                arquivoPreview,
                downloadLink
            }));
        };

        // PDF é lido como ArrayBuffer para manter o conteúdo binário e imagem como base64
        if (TIPOS_PDF.includes(fileType)) {
            reader.readAsArrayBuffer(file);
        } else if (TIPOS_IMAGEM.includes(fileType)) {
            reader.readAsDataURL(file);
        }
    };

    /* Clicar para salvar */
    onClickSave = async () => {
        const { isNewRecord, mensagem } = this.state;
        const { history } = this.props;

        const errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            return;
        }

        try {
            if (isNewRecord) {
                await api.post('/whatsapp/mensagemfornecedor', {
                    ...mensagem,
                    codusuarioregistrou: getCodUsuarioRegistrou()
                });
            } else {
                await api.put(`/whatsapp/mensagemfornecedor/${mensagem.idmsgwhats}`, mensagem);
            }

            history.push(ROTA_LISTA);
        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);

            this.handleOpenAlert(
                getApiErrorMessage(
                    error,
                    'Erro ao salvar!'
                )
            );
        }
    };

    /* Clicar para cancelar */
    onClickCancel = () => {
        this.props.history.push(ROTA_LISTA);
    };

    /* Valida os campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { mensagem } = this.state;
        const { descricao, tipomensagem } = mensagem;

        const errors = {};

        if (!descricao || String(descricao).trim() === '') {
            errors.descricao = 'Descrição obrigatória';
        }

        if (!tipomensagem || isNaN(tipomensagem)) {
            errors.tipomensagem = 'Tipo de mensagem obrigatório';
        }

        return errors;
    };

    render() {
        const {
            arquivoPreview,
            downloadLink,
            errors,
            isView,
            mensagem,
            messageAlert,
            modelosrelatorio,
            openAlert,
            openDictionaryModal
        } = this.state;

        const {
            botao1,
            botao2,
            codmodelorelatorio,
            descricao,
            idmsgwhats,
            inativo,
            mensagemconfirmacaorecebimento,
            msg,
            nomearquivo,
            recurso,
            tipoarquivo,
            tipomensagem
        } = mensagem;

        const trabaceiterecebmsgwhatsapp = (
            getConfigField('trabaceiterecebmsgwhatsapp', 'cfg_crm') == ASIM
        );

        const isTexto = (tipomensagem === 1 || tipomensagem === 4);
        const isDocumento = (tipomensagem === 2);
        const isImagem = (tipomensagem === 3);
        const isArquivoFixo = ((isDocumento && tipoarquivo === 1) || isImagem);
        const isArquivoDinamico = (isDocumento && tipoarquivo === 2);

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Mensagem {idmsgwhats}
                        </Typography>

                        <FormStatusSwitch
                            checked={inativo !== ASIM}
                            name="inativo"
                            onChange={this.onChange}
                            disabled={isView}
                        />
                    </Box>

                    <br />

                    <TextField
                        label="Descrição"
                        name="descricao"
                        value={descricao || ''}
                        variant="outlined"
                        onChange={this.onChange}
                        helperText={errors.descricao || ' '}
                        error={!!errors.descricao}
                        disabled={isView}
                        inputProps={{ maxLength: 100 }}
                        fullWidth
                    />

                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            rowGap: 10,
                            columnGap: 15,
                            marginTop: 10
                        }}
                    >
                        <FormControl
                            variant="outlined"
                            disabled={isView}
                            error={!!errors.tipomensagem}
                            style={{
                                marginTop: 16,
                                width: 200
                            }}
                        >
                            <InputLabel id="tipo-mensagem-label">
                                Tipo mensagem
                            </InputLabel>

                            <Select
                                labelId="tipo-mensagem-label"
                                name="tipomensagem"
                                value={tipomensagem || ''}
                                onChange={this.onChange}
                                label="Tipo mensagem"
                                MenuProps={MENU_PROPS}
                            >
                                <MenuItem value={1}>
                                    Mensagem texto
                                </MenuItem>

                                <MenuItem value={2}>
                                    Documento
                                </MenuItem>

                                <MenuItem value={3}>
                                    Imagem
                                </MenuItem>

                                <MenuItem value={4}>
                                    Lista de botões
                                </MenuItem>
                            </Select>

                            <FormHelperText>
                                {errors.tipomensagem || ' '}
                            </FormHelperText>
                        </FormControl>

                        {isTexto && (
                            <Button
                                variant="contained"
                                color="default"
                                style={ESTILO_BOTAO_CINZA}
                                disabled={isView}
                                startIcon={<Book />}
                                onClick={this.openDictionaryModal}
                            >
                                Dicionário
                            </Button>
                        )}

                        {isDocumento && (
                            <FormControl disabled={isView}>
                                <FormLabel>
                                    Tipo arquivo
                                </FormLabel>

                                <RadioGroup
                                    row
                                    name="tipoarquivo"
                                    value={tipoarquivo || ''}
                                    onChange={this.onChange}
                                >
                                    <FormControlLabel
                                        value={1}
                                        control={<Radio />}
                                        label="Fixo"
                                    />

                                    <FormControlLabel
                                        value={2}
                                        control={<Radio />}
                                        label="Dinâmico"
                                    />
                                </RadioGroup>
                            </FormControl>
                        )}

                        {isArquivoFixo && (
                            <FormGroup>
                                <input
                                    accept={isImagem ? 'image/*' : '.pdf'}
                                    type="file"
                                    id="upload-button-file"
                                    style={{ display: 'none' }}
                                    onChange={this.handleImageUpload}
                                    disabled={isView}
                                />

                                <label htmlFor="upload-button-file">
                                    <Button
                                        variant="contained"
                                        component="span"
                                        startIcon={isDocumento ? <Description /> : <PhotoCamera />}
                                        disabled={isView}
                                        style={ESTILO_BOTAO_CINZA}
                                    >
                                        {isDocumento ? 'Escolher Arquivo' : 'Escolher Imagem'}
                                    </Button>
                                </label>
                            </FormGroup>
                        )}

                        {(isDocumento && tipoarquivo === 1 && downloadLink) && (
                            <div>
                                <a
                                    href={downloadLink}
                                    download={nomearquivo}
                                    style={{
                                        display: 'inline-block',
                                        padding: '8px 12px',
                                        backgroundColor: '#007bff',
                                        color: '#fff',
                                        textDecoration: 'none',
                                        borderRadius: 4,
                                        fontSize: 14
                                    }}
                                >
                                    {nomearquivo}
                                </a>
                            </div>
                        )}

                        {isArquivoDinamico && (
                            <FormControl
                                variant="outlined"
                                style={{ width: 200 }}
                                disabled={isView}
                            >
                                <InputLabel id="recurso-label">
                                    Recurso
                                </InputLabel>

                                <Select
                                    labelId="recurso-label"
                                    name="recurso"
                                    value={recurso || ''}
                                    onChange={this.onChange}
                                    label="Recurso"
                                    MenuProps={MENU_PROPS}
                                >
                                    <MenuItem value={ATIPO_MODELO_RELATORIO_PARA_MAPA_DE_TRANSPORTE}>
                                        Mapa de transporte
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        )}

                        {isArquivoDinamico && (
                            <FormControl
                                variant="outlined"
                                style={{ width: 400 }}
                                disabled={isView}
                            >
                                <InputLabel id="modelo-relatorio-label">
                                    Modelo de relatório
                                </InputLabel>

                                <Select
                                    labelId="modelo-relatorio-label"
                                    name="codmodelorelatorio"
                                    value={codmodelorelatorio || ''}
                                    onChange={this.onChange}
                                    label="Modelo de relatório"
                                    MenuProps={MENU_PROPS}
                                >
                                    {modelosrelatorio.map(modelo => (
                                        <MenuItem
                                            key={modelo.codigo}
                                            value={modelo.codigo}
                                        >
                                            {modelo.nome}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}
                    </div>

                    <br />

                    <FormGroup>
                        {isTexto && (
                            <textarea
                                id="msg"
                                name="msg"
                                onChange={this.onChange}
                                style={{ height: 150 }}
                                value={msg || ''}
                                disabled={isView}
                            />
                        )}

                        {(tipomensagem === 4) && (
                            <FormGroup
                                row
                                style={{
                                    gap: 10,
                                    marginTop: 10
                                }}
                            >
                                <TextField
                                    label="Botão 1 (Aceitar)"
                                    name="botao1"
                                    value={botao1 || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ width: 150 }}
                                />

                                <TextField
                                    label="Botão 2 (Recusar)"
                                    name="botao2"
                                    value={botao2 || ''}
                                    variant="outlined"
                                    onChange={this.onChange}
                                    disabled={isView}
                                    inputProps={{ maxLength: 20 }}
                                    style={{ width: 150 }}
                                />

                                {trabaceiterecebmsgwhatsapp && (
                                    <FormControlLabel
                                        label="Mensagem para confirmar se fornecedor deseja receber mensagens"
                                        control={
                                            <Checkbox
                                                checked={mensagemconfirmacaorecebimento === ASIM}
                                                name="mensagemconfirmacaorecebimento"
                                                onChange={this.onChange}
                                                color="primary"
                                                disabled={isView}
                                            />
                                        }
                                    />
                                )}
                            </FormGroup>
                        )}

                        {(isImagem && arquivoPreview) && (
                            <FormGroup>
                                <div>
                                    <img
                                        src={arquivoPreview}
                                        alt="Pré-visualização"
                                        style={{
                                            maxHeight: 300,
                                            width: 'auto',
                                            height: 'auto',
                                            maxWidth: '100%',
                                            border: '1px solid #ccc',
                                            borderRadius: 4
                                        }}
                                    />

                                    <Typography variant="body2">
                                        {nomearquivo}
                                    </Typography>
                                </div>
                            </FormGroup>
                        )}
                    </FormGroup>

                    <br />
                    <br />

                    <FormActions
                        onSave={this.onClickSave}
                        onCancel={this.onClickCancel}
                        disableSave={isView}
                    />
                </CardContent>

                <AlertInformation
                    open={openAlert}
                    message={messageAlert}
                    handleClose={this.handleCloseAlert}
                />

                <Dialog
                    open={openDictionaryModal}
                    onClose={this.closeDictionaryModal}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>
                        Dicionário de dados
                    </DialogTitle>

                    <DialogContent>
                        <DicionarioDadosFornecedor />
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.closeDictionaryModal}
                            color="primary"
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
};

MsgWhatsAppFornecedorForm.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    location: PropTypes.object
};

export default MsgWhatsAppFornecedorForm;